export const RECORDING_MODES = {
  SPIROMETRY: "spirometry",
  TIDAL: "tidal-breathing",
  PULSE: "pulse-scan",
  POSTEXERTION: "post-exertion",
  MAUDIO: "manual-audio",
};

export const ALL_MODES = Object.values(RECORDING_MODES);
